import React from "react";
import {NavLink} from "react-router-dom";

const Link = ({route, icon, notxt, ...props}) => {
    const linkTxt = notxt ? '': route.title;
    return route.Component === null ?
        <a
            href={route.path}
            {...props}
        >{icon} {linkTxt}
        </a>
        :
        <NavLink
            to={route.path}
            {...props}
        >{icon} {linkTxt}
        </NavLink>
}

export default Link
